import { render, staticRenderFns } from "./SimMenuLink.vue?vue&type=template&id=29d819ec&scoped=true&"
import script from "./SimMenuLink.vue?vue&type=script&lang=js&"
export * from "./SimMenuLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d819ec",
  null
  
)

export default component.exports